export enum EmailValidationRequest {
    ACTIVATE_USER = 'resend-activation-code',
    FORGOT_PASSWORD = 'forgot-password',
    DELETE_USER = 'users',
}
